import { render, staticRenderFns } from "./bkPolicyHealthCheckPDF.vue?vue&type=template&id=cf0d443c&scoped=true"
import script from "./bkPolicyHealthCheckPDF.vue?vue&type=script&lang=js"
export * from "./bkPolicyHealthCheckPDF.vue?vue&type=script&lang=js"
import style0 from "./bkPolicyHealthCheckPDF.vue?vue&type=style&index=0&id=cf0d443c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0d443c",
  null
  
)

export default component.exports